import { j as e } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as r } from "react";
import { I as i } from "../../../../IconBase-CxZyIWw2.js";
const t = r((o, l) => /* @__PURE__ */ e.jsx(
  i,
  {
    ref: l,
    ...o,
    image: (s) => /* @__PURE__ */ e.jsx(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...s,
        children: /* @__PURE__ */ e.jsx(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M14.543 5.293c-3.752 3.752-9.334 3.752-13.086 0L.043 6.707c.5.501 1.03.946 1.58 1.337l-1.49 2.58 1.733 1 1.484-2.57q.856.404 1.746.653l-.512 2.907 1.97.347.51-2.895q.936.081 1.871 0l.51 2.895 1.97-.347-.512-2.907a11 11 0 0 0 1.747-.653l1.484 2.57 1.732-1-1.49-2.58q.828-.585 1.581-1.337z",
            clipRule: "evenodd"
          }
        )
      }
    )
  }
));
t.displayName = "EyeClosedIcon";
export {
  t as EyeClosedIcon,
  t as default
};
//# sourceMappingURL=index.js.map
